import { InteractionType } from '@azure/msal-browser';
import { type MsalAuthenticationResult, MsalAuthenticationTemplate } from '@azure/msal-react';
import { type PropsWithChildren } from 'react';

import { PageLoadingFullscreen } from '../../components/general/PageLoadingFullscreen.tsx';
import { loginRequest } from '../../utils/loginRequest';

const ErrorWrapper = (result: MsalAuthenticationResult) => {
  throw new Error('Authentifizierungsfehler', { cause: result.error });
};

const Loading = () => <PageLoadingFullscreen msg="Du wirst eingeloggt..." />;

export const WithAuth = ({ children }: PropsWithChildren) => (
  <MsalAuthenticationTemplate
    authenticationRequest={loginRequest}
    errorComponent={ErrorWrapper}
    interactionType={InteractionType.Redirect}
    loadingComponent={Loading}
  >
    {children}
  </MsalAuthenticationTemplate>
);
